import { Stack } from "@mui/material";
import data from '../../data/data.json';

const AboutBanner = () => {
    return (
        <>
            <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                overflow='hidden'
                width='100%'
                spacing={{xs: 1, md: 2}}
            >
                {
                    data.about.banner.map((item, index) => {
                        return <img 
                            key={index}
                            src={item} 
                            alt='Team' 
                            width='30%'
                            style={{
                                borderRadius: '16px'
                            }}
                            data-aos="zoom-in-down"
                            data-aos-delay={index * 150}
                            data-aos-duration="1000"
                        />
                    })
                }
            </Stack>
        </>
    );
}

export default AboutBanner;